import React from "react";
interface TabButtonProps<T> {
  value: T;
  currentTab: T;
  icon: JSX.Element;
  label: string;
  small?: boolean;
}
export function TabButton<T>({
  value,
  currentTab,
  icon,
  label,
  small
}: TabButtonProps<T>) {
  let classNames = `w-full flex ${small ? "h-14 flex-row gap-3" : "h-24 flex-col tablet:w-44 gap-2"} items-center justify-center rounded-xl p-4 text-primary-foreground duration-200 transition active:scale-95 drop-shadow-md backdrop-blur-sm `;
  if (value === currentTab) {
    classNames += "bg-primary/80 hover:bg-primary/70";
  } else {
    classNames += "bg-background/95 text-secondary-foreground hover:bg-background/60";
  }
  return <button className={classNames} data-sentry-component="TabButton" data-sentry-source-file="TabButton.tsx">
      {icon}
      <span className="text-xs font-semibold uppercase drop-shadow-sm">{label}</span>
    </button>;
}